import React, { forwardRef, useCallback, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useClasses, createUseStyles, Text, useTheme } from '@Sage/hoi-poi-ui';
import { RichTextContext } from "../../";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'EmojiList');
const EmojiList = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    texts,
    command,
    classes: classesProp,
    items = [],
    query
  } = _ref;
  const {
    saveCache
  } = useContext(RichTextContext);
  const classes = useClasses(useStyles, classesProp);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const theme = useTheme();
  useEffect(() => setSelectedIndex(0), [items]);
  const selectItem = useCallback(index => {
    const item = items[index];
    if (item) {
      command({
        name: item.name
      });
      saveCache(item.name);
    }
  }, [command, items, saveCache]);
  return query.length >= 3 ? /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: ref
  }, items.length ? items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.item, {
      [classes.selected]: index === selectedIndex
    }),
    key: index,
    onClick: () => selectItem(index)
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme.colors.textLight.primary,
    type: "body",
    className: classes.emojiItem,
    isTruncated: true
  }, /*#__PURE__*/React.createElement("span", null, item.fallbackImage ? /*#__PURE__*/React.createElement("img", {
    src: item.fallbackImage,
    alt: item.name
  }) : item.emoji), /*#__PURE__*/React.createElement("span", null, ":", item.name, ":")))) : /*#__PURE__*/React.createElement(Text, null, (texts === null || texts === void 0 ? void 0 : texts.noResults) || 'No Results')) : null;
});
export default EmojiList;